import React from 'react';
import { useService } from '@core/inversify-react';
import { IGetDeclarationsExportTasksRepo, GetDeclarationsExportTasksRepoType, ExportDeclarationsExcelRepoType, IExportDeclarationsExcelRepo } from '../repos';
import { IExportDeclarationTask } from '../interfaces';
import { useQuery } from 'react-query';
import { HttpStatusCode } from '@core/http';
import { message } from 'antd';

export const useDeclarationsExportTasks = () => {
  const getDeclarationsExportTasksRepo = useService<IGetDeclarationsExportTasksRepo>(GetDeclarationsExportTasksRepoType);
  const exportDeclarationsExcelRepo = useService<IExportDeclarationsExcelRepo>(ExportDeclarationsExcelRepoType);
  const [fetchCount, setFetchCount] = React.useState(0);

  const isCheckBtnEnabled = fetchCount > 50;
  const refetchInterval = isCheckBtnEnabled ? false : 1000 * 3;

  const exportQuery = useQuery<IExportDeclarationTask[], string, IExportDeclarationTask[], ['declarations', 'export-tasks']>(
    ['declarations', 'export-tasks'],
    async () => {
      const result = await getDeclarationsExportTasksRepo.execute({ sort_column: 'id', sort_order: 'desc' });
      setFetchCount((prev) => prev + 1);

      if (result.status === HttpStatusCode.OK) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    { refetchInterval },
  );

  const handleDownload = async (id: string) => {
    const result = await exportDeclarationsExcelRepo.execute(id);
    if (result.status === HttpStatusCode.OK) {
      message.success({ key: 1, content: 'Sənəd yüklənir' });
      const blob = result.response;
      const objectURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectURL;
      a.download = `declarations_excel_${Math.round(Math.random() * 1000)}.xls`;
      a.click();
      a.remove();
    } else {
      message.error(result.response);
    }
  };

  return { ...exportQuery, handleDownload, isCheckBtnEnabled };
};
